import { Form, Input, Row } from 'antd'
import type React from 'react'
import type { BaseInputProps } from '../../types/types'
import './InputName.less'

export type InputNameProps = {
  onChangeFirst?: (e?: React.ChangeEvent<HTMLInputElement>) => void
  onChangeLast?: (e?: React.ChangeEvent<HTMLInputElement>) => void
  layout?: 'column' | 'row'
  value?: { firstName?: string; lastName?: string }
  placeholder?: { firstName: string; lastName: string }
  label?: string
  localization?: { firstNameError: string; lastNameError: string }
} & Omit<BaseInputProps, 'placeholder'>

function InputName({
  label,
  value,
  placeholder,
  disabled,
  layout = 'row',
  onChangeFirst,
  onChangeLast,
  localization,
  ...props
}: InputNameProps) {
  const styles = {
    firstName: {
      marginRight: 10
    }
  }
  return (
    <Row id="name">
      <Form.Item
        label={label}
        name="firstname"
        labelCol={layout === 'column' ? { span: 24 } : {}}
        wrapperCol={layout === 'column' ? { span: 24 } : {}}
        rules={[
          {
            required: true,
            message: localization?.firstNameError || 'First name is required!'
          },
          {
            validator: (_, value) =>
              !value.includes(' ')
                ? Promise.resolve()
                : Promise.reject(new Error('No spaces allowed'))
          }
        ]}
      >
        <Input
          placeholder={placeholder?.firstName || 'Placeholder'}
          value={value?.firstName}
          onChange={onChangeFirst}
          disabled={disabled}
          style={styles.firstName}
          {...props}
        />
      </Form.Item>
      <Form.Item
        name="lastname"
        labelCol={layout === 'column' ? { span: 24 } : {}}
        wrapperCol={layout === 'column' ? { span: 24 } : {}}
        rules={[
          {
            required: true,
            message: localization?.lastNameError || 'Last name is required!'
          },
          {
            validator: (_, value) =>
              !value.includes(' ')
                ? Promise.resolve()
                : Promise.reject(new Error('No spaces allowed'))
          }
        ]}
      >
        <Input
          placeholder={placeholder?.lastName || 'Placeholder'}
          value={value?.lastName}
          onChange={onChangeLast}
          disabled={disabled}
          {...props}
        />
      </Form.Item>
    </Row>
  )
}

export default InputName
